const RAW_SCHOOLS = [
  {
    id: 1,
    name: '№1 жалпы орта білім беретін мектеп',
    addr: '060100 Құлсары қаласы, Махамбет даңғылы 1365-45-79',
    cap: 1176,
    shift: 2,
    kz: true,
    ru: false,
    st: 1238,
    tch: 129,
  },
  {
    id: 2,
    name: '№2 жалпы орта білім беретін мектеп',
    addr: '060108 Қосшағыл ауылы, Жайық 93',
    cap: 880,
    shift: 2,
    kz: true,
    ru: false,
    st: 733,
    tch: 99,
  },
  {
    id: 3,
    name: '№3 жалпы орта білім беретін мектеп',
    addr: '060111 Шоқпартоғай ауылы, Т.Дешенов көшесі 378 ғимарат',
    cap: 440,
    shift: 2,
    kz: true,
    ru: false,
    st: 625,
    tch: 71,
  },
  {
    id: 4,
    name: '№4 М.Әуезов атындағы жалпы орта білім беретін мектеп',
    addr: '060110 Тұрғызба ауылы, Бөкен би 409',
    cap: 620,
    shift: 2,
    kz: true,
    ru: false,
    st: 725,
    tch: 91,
  },
  {
    id: 5,
    name: '№5 Абай атындағы жалпы орта білім беретін мектеп',
    addr: '060103 Құлсары қаласы, Дүйсенғали Әжіғалиев, құрылыс 67',
    cap: 300,
    shift: 2,
    kz: true,
    ru: false,
    st: 597,
    tch: 76,
  },
  {
    id: 6,
    name: '№6 жалпы орта білім беретін мектеп',
    addr: '060100 Құлсары қаласы, Махамбет даңғылы, 72',
    cap: 940,
    shift: 2,
    kz: true,
    ru: true,
    st: 2154,
    tch: 127,
  },
  {
    id: 7,
    name: '№7 Е.Халықов атындағы жалпы орта білім беретін мектеп',
    addr: '060100 Құлсары қаласы, Күржәманұлы Қашаған көшесі 53 ғимарат',
    cap: 1200,
    shift: 1,
    kz: true,
    ru: false,
    st: 574,
    tch: 89,
  },
  {
    id: 8,
    name: '№8 жалпы орта білім беретін мектеп',
    addr: '060100 Құлсары қаласы, 199 көше 8 ғимарат',
    cap: 600,
    shift: 2,
    kz: true,
    ru: true,
    st: 1339,
    tch: 124,
  },
  {
    id: 9,
    name: '№9 жалпы орта білім беретін мектеп',
    addr: '060100 Құлсары қаласы, Махамбет даңғылы 102',
    cap: 1160,
    shift: 2,
    kz: true,
    ru: true,
    st: 1618,
    tch: 119,
  },
  {
    id: 10,
    name: '№10 Амангелді атындағы жалпы орта білім беретін мектеп',
    addr: '060104 Ақкиізтоғай ауылы, С.Аронұлы 210',
    cap: 320,
    shift: 2,
    kz: true,
    ru: false,
    st: 350,
    tch: 45,
  },
  {
    id: 11,
    name: '№13 жалпы орта білім беретін мектеп',
    addr: '060101 Құлсары қаласы, Тәуекел Хан көшесі ғимарат 2',
    cap: 600,
    shift: 2,
    kz: true,
    ru: false,
    st: 929,
    tch: 80,
  },
  {
    id: 12,
    name: '№15 Сүлеймен Карабалин атындағы жалпы орта білім беретін мектеп',
    addr: '060102 Құлсары қаласы, А.Қорғанбаев көшесі, 50',
    cap: 488,
    shift: 2,
    kz: true,
    ru: false,
    st: 408,
    tch: 47,
  },
  {
    id: 13,
    name: '№16 Д.Жазықбаев атындағы жалпы орта білім беретін мектеп',
    addr: '060100 Құлсары қаласы, 217 көше 42 ғимарат',
    cap: 754,
    shift: 2,
    kz: true,
    ru: true,
    st: 1016,
    tch: 104,
  },
  {
    id: 14,
    name: '№17 жалпы орта білім беретін мектеп',
    addr: '060105 Майкөмген ауылы, Ақтан Керейулы №56',
    cap: 260,
    shift: 2,
    kz: true,
    ru: false,
    st: 236,
    tch: 34,
  },
  {
    id: 15,
    name: '№18 М.Сатыбалдиев атындағы жалпы орта білім беретін мектеп',
    addr: '060100 Құлсары қаласы, 221 көше №59 үй',
    cap: 1580,
    shift: 2,
    kz: true,
    ru: true,
    st: 2334,
    tch: 193,
  },
  {
    id: 16,
    name: '№19 жалпы орта білім беретін мектеп',
    addr: '060100 Құлсары қаласы, Н.Арқабаев көшесі, 22 ғимарат',
    cap: 300,
    shift: 2,
    kz: true,
    ru: false,
    st: 645,
    tch: 82,
  },
  {
    id: 17,
    name: '№20 жалпы орта білім беретін мектеп',
    addr: '060100 Құлсары қаласы, Балуан Шолақ, ғимарат-1',
    cap: 340,
    shift: 2,
    kz: true,
    ru: false,
    st: 312,
    tch: 44,
  },
  {
    id: 18,
    name: '№21 жалпы орта білім беретін мектеп',
    addr: '060100 Құлсары қаласы, Ж.Нұрмахан көшесі 3 ғимарат',
    cap: 300,
    shift: 2,
    kz: true,
    ru: false,
    st: 1070,
    tch: 92,
  },
  {
    id: 19,
    name: '№22 жалпы орта білім беретін мектеп',
    addr: '060106 Жаңа Каратон кенті, Боран Ержанов көшесі, құрылыс 642',
    cap: 720,
    shift: 2,
    kz: true,
    ru: true,
    st: 848,
    tch: 95,
  },
  {
    id: 20,
    name: '№23 жалпы орта білім беретін мектеп',
    addr: '060106 Жаңа Каратон кенті, Рзиев Балагул №883 ғимарат',
    cap: 436,
    shift: 2,
    kz: true,
    ru: true,
    st: 545,
    tch: 75,
  },
];

const clampDef = (st, cap) => Math.max(st - cap, 0);
const clampSur = (cap, st) => Math.max(cap - st, 0);

function toApiRow(r) {
  return {
    id: r.id,
    name: r.name,
    address: r.addr,
    capacity: r.cap,
    shift: r.shift,
    lang_kz: r.kz,
    lang_ru: r.ru,
    students: r.st,
    teachers: r.tch,
    deficit: clampDef(r.st, r.cap),
    surplus: clampSur(r.cap, r.st),
  };
}

export function buildMeta() {
  return {
    shifts: [
      { value: 1, name_ru: 'Односменная', name_kk: 'Бір ауысымды' },
      { value: 2, name_ru: 'Двухсменная', name_kk: 'Екі ауысымды' },
    ],
    languages: [
      { code: 'kz', name_ru: 'Казахский', name_kk: 'Қазақ' },
      { code: 'ru', name_ru: 'Русский', name_kk: 'Орыс' },
      { code: 'kz_ru', name_ru: 'Казахский и русский', name_kk: 'Қазақ және орыс' },
    ],
  };
}

export const MOCK_STORE = {
  rows: RAW_SCHOOLS.map(toApiRow),
  nextId: 21,
};

export { clampDef, clampSur };
